import { Link } from 'react-router-dom'
import {
  Tag,
  Package,
  Layers,
  CalendarDays,
  ShoppingCart,
  Warehouse,
  BarChart3,
  Settings,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { HOME_MODULES } from '@/config/navigation'
import { Breadcrumb } from '@/components/layout/Breadcrumb'
import { PageHeader } from '@/components/layout/PageHeader'

const iconMap: Record<string, LucideIcon> = {
  sales: Tag,
  products: Package,
  catalog: Layers,
  planning: CalendarDays,
  purchasing: ShoppingCart,
  warehouse: Warehouse,
  reports: BarChart3,
  admin: Settings,
}

export function HomePage() {
  return (
    <div>
      <Breadcrumb items={[{ label: 'Trang chủ' }]} />
      <PageHeader title="MENU" subtitle="Furniture ERP" />

      <div className="mx-auto grid max-w-4xl grid-cols-2 gap-3 sm:grid-cols-3">
        {HOME_MODULES.map((mod) => {
          const Icon = iconMap[mod.id] ?? Package
          const firstLive = mod.children?.find((c) => c.path && !c.disabled)
          const to = firstLive?.path ?? mod.path
          return (
            <Link
              key={mod.id}
              to={to}
              className="flex flex-col items-center gap-3 rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-6 text-center shadow-[var(--shadow-level-1)] transition-colors hover:border-[var(--color-accent)] hover:bg-[var(--color-accent-soft)]"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-[var(--radius-md)] bg-[var(--color-accent)] text-white">
                <Icon className="h-6 w-6" strokeWidth={1.8} />
              </div>
              <span className="text-sm font-semibold text-[var(--color-text)]">
                {mod.label}
              </span>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
